import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  PoMenuItem,
  PoModalAction,
  PoModalComponent,
  PoToolbarAction,
  PoToolbarProfile
} from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { SessionService } from './services/session/session.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { version } from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  disabled = true;

  fornecedorForm: FormGroup = this.fb.group({
    cnpj: ['', [Validators.required, Validators.minLength(14)]],
  });

  public isLoggedInMenu$: Observable<boolean>;
  public isLogged = false;
  public tituloEmpresa = '';

  public profile: PoToolbarProfile = {
    title: '',
    // avatar: '../assets/img/short_logo.png',
    subtitle: ''
  };

  public profileActions: Array<PoToolbarAction> = [
    { label: 'Logout', action: () => this.sessionService.logout(), icon: 'po-icon po-icon-exit', type: 'danger' }
  ];

  public menus: Array<PoMenuItem> = [
    { label: 'Pré Nota', link: '/nota-fiscal', icon: 'po-icon po-icon-sale', shortLabel: 'Pré Nota' },
    { label: 'Cotação', link: '/cotacao', icon: 'po-icon po-icon-sale', shortLabel: 'Cotação' },
    { label: 'Reembolsos Despesas', link: '/reembolsos-despesas', icon: 'po-icon po-icon-balance', shortLabel: 'R. Despesas' }
  ];

  public token: string;

  menuItemSelected: string;

  version;
  /* Modal CNPJ*/

  @ViewChild('poModal', { static: true }) poModal: PoModalComponent;

  confirm: PoModalAction = {
    action: () => {
      this.buscarFornecedor();
    },
    label: 'Confirmar',
    disabled: true
  };

  close: PoModalAction = {
    action: () => {
      this.poModal.close();
    },
    label: 'Cancelar',
    danger: false
  };

  /* Modal Sobre*/

  @ViewChild('modalSobre', { static: true }) modalSobre: PoModalComponent;

  voltar: PoModalAction = {
    action: () => {
      this.modalSobre.close();
    },
    label: 'Voltar',
    danger: false
  };

  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    localStorage.setItem(`version`, version);
    this.menus = [];
    this.sessionService.isLogged$
      .subscribe((data) => {
        this.isLogged = data;
        this.token = sessionStorage.getItem('token');
        this.createMenu();
      });

    this.version = version;

    this.sessionService.info$
      .subscribe((data: any) => {
        this.profile.title = `Nome: ${data?.AI3_NOME}`;
        this.profile.subtitle = `Código: ${data?.AI3_CODUSU}`;
      });

    this.controls.cnpj.valueChanges.subscribe((data) => {
      if (data.length === 14) {
        this.confirm.disabled = false;
      }
    });

    this.tituloEmpresa = this.sessionService.nomeEmpresa;
  }

  createMenu() {
    this.menus = [
      // { label: 'Pré Nota', icon: 'po-icon po-icon-sale', shortLabel: 'Pré Nota', action: this.openFornecedor.bind(this) },
      { label: 'Nota Fiscal', link: '/nota-fiscal', icon: 'po-icon po-icon-sale', shortLabel: 'Nota Fiscal' },
      // {
      //   label: 'Cotações', icon: 'po-icon po-icon-sale', shortLabel: 'Cotações', subItems: [
      //     {
      //       label: 'Em Aberto', link: '/cotacao/em-aberto'
      //     },
      //     // {
      //     //   label: 'Finalizadas', link: '/cotacao/finalizadas'
      //     // },
      //   ]
      // }
      // { label: 'Reembolsos Despesas', link: '/reembolsos-despesas', icon: 'po-icon po-icon-balance', shortLabel: 'R. Despesas' }
    ];
    // this.loginService
    //   .login(token)
    //   .subscribe((data) => {
    //     if (data['MENUS'].length > 0) {
    //       let arr: Array<any> = data['MENUS']
    //       arr.sort((a, b) => {
    //         if (a.ZM0_ORDEM < b.ZM0_ORDEM) {
    //           return -1;
    //         } else if (a.ZM0_ORDEM > b.ZM0_ORDEM) {
    //           return 1;
    //         } else {
    //           return 0;
    //         }
    //       })

    //       this.menus = arr.map((item) => {
    //         return <PoMenuItem>{
    // label: item['ZM0_MENU'], link: item['ZM0_ROTA'], shortLabel: item['ZM0_DCURTA'], icon: item['ZM0_ICONE'] }
    //       })
    this.menus.push({ label: 'Sobre', action: this.openSobre.bind(this), shortLabel: 'Sobre', icon: 'po-icon po-icon-help' });
    //     }

    //     this.profile.title = data['ZM3_NOME'];
    //   })
  }
  get controls() {
    return this.fornecedorForm.controls;
  }

  openFornecedor() {
    this.poModal.open();
  }

  openSobre() {
    this.modalSobre.open();
  }

  buscarFornecedor() {
    if (this.fornecedorForm.valid) {
      console.log(this.controls.cnpj.value);
      this.router.navigate(['/nota-fiscal']);
      this.poModal.close();
    }
  }

  ngOnDestroy() {
    this.menus = [];
  }

}
